/* eslint-disable linebreak-style */
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LockOpenOutlined } from '@material-ui/icons';
import { withStyles, CircularProgress } from '@material-ui/core';
import { EHRresetpassword } from 'services/user/action';
import styles from '../../../SignIn/style';

const Passwordreset = props => {
  const { classes } = props;

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    if (isAndroid) {
      // Redirect to Android app
      window.location.href = `https://play.google.com/store/apps/details?id=com.ehrzip.patient`;
    } else if (isIOS) {
      // Redirect to iOS app
      window.location.href = `https://apps.apple.com/app/id6759051730`;
    } else {
      window.location.href = `https://play.google.com/store/apps/details?id=com.ehrzip.patient`;
    }
  }, []);

  return (
    <span>
      <div
        className={classes.contentBodyMsg}
        style={{ position: 'relative' }}
      >
        <div className={classes.contentHeader}>
          <LockOpenOutlined />
        </div>
        <div className={classes.contentInner}>
          <CircularProgress size={50} className={classes.progress} />
        </div>
      </div>
    </span>
  );
};

Passwordreset.propTypes = {
  history: PropTypes.object
};

const mapDispatchToProps = { EHRresetpassword };

const mapStateToProps = _state => ({});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(Passwordreset))
);
